var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckStatements(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2714 5.43835L31.4744 5.43837",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2714 8.76733L31.4744 8.76734",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0078 11.1041H9.15552V10.4791H13.0078V11.1041ZM11.7805 8.84276H9.13279V8.19503H11.7805V8.84276ZM10.3714 7.04731L10.4623 9.51322C10.4737 9.75185 10.4519 9.9725 10.397 10.1751C10.344 10.3759 10.2407 10.5303 10.0873 10.6382L9.38279 10.4791C9.49643 10.4791 9.58355 10.4223 9.64416 10.3087C9.70476 10.195 9.74548 10.0625 9.76632 9.91094C9.78715 9.75943 9.79567 9.62685 9.79188 9.51322L9.71234 7.04731C9.69719 6.63443 9.772 6.29163 9.93677 6.0189C10.1034 5.74617 10.3212 5.54257 10.5902 5.4081C10.861 5.27363 11.1442 5.2064 11.4396 5.2064C11.7104 5.2064 11.9567 5.25564 12.1782 5.35413C12.3998 5.45072 12.5864 5.5814 12.7379 5.74617C12.8894 5.91094 12.9955 6.09655 13.0561 6.30299C13.1167 6.50753 13.1195 6.71776 13.0646 6.93367L12.4055 6.75185C12.432 6.55488 12.4017 6.38822 12.3146 6.25185C12.2294 6.1136 12.1101 6.00943 11.9567 5.93935C11.8051 5.86738 11.6442 5.8314 11.4737 5.8314C11.2919 5.8314 11.1167 5.87496 10.9481 5.96208C10.7796 6.04731 10.6413 6.17988 10.5334 6.35981C10.4254 6.53784 10.3714 6.767 10.3714 7.04731Z",
    fill: "#F4F4F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2714 12.0961H31.4744",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 17.644V34.2882",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9 34.2881H31.1924",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9 20.9728H10.3315",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9 24.3018H10.3315",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9 27.6305H10.3315",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9 30.9591H10.3315",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8822 34.2882V32.9567",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8755 34.2882V32.9567",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8688 34.2882V32.9567",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8623 34.2882V32.9567",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9918 23.192H12.7726C12.5275 23.192 12.3287 23.3906 12.3287 23.6359V31.0702C12.3287 31.3154 12.5275 31.514 12.7726 31.514H14.9918C15.2369 31.514 15.4357 31.3154 15.4357 31.0702V23.6359C15.4357 23.3906 15.2369 23.192 14.9918 23.192Z",
    stroke: "#F4F4F9",
    strokeWidth: 1.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9853 20.9728H17.7661C17.5209 20.9728 17.3223 21.2244 17.3223 21.535V30.9518C17.3223 31.2623 17.5209 31.514 17.7661 31.514H19.9853C20.2303 31.514 20.4292 31.2623 20.4292 30.9518V21.535C20.4292 21.2244 20.2303 20.9728 19.9853 20.9728Z",
    stroke: "#F4F4F9",
    strokeWidth: 1.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9785 16.7562H22.7593C22.514 16.7562 22.3154 16.9451 22.3154 17.1781V31.0924C22.3154 31.3254 22.514 31.514 22.7593 31.514H24.9785C25.2235 31.514 25.4223 31.3254 25.4223 31.0924V17.1781C25.4223 16.9451 25.2235 16.7562 24.9785 16.7562Z",
    stroke: "#F4F4F9",
    strokeWidth: 1.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9715 22.0824H27.7523C27.5073 22.0824 27.3085 22.2812 27.3085 22.5265V31.0703C27.3085 31.3155 27.5073 31.5141 27.7523 31.5141H29.9715C30.2168 31.5141 30.4154 31.3155 30.4154 31.0703V22.5265C30.4154 22.2812 30.2168 22.0824 29.9715 22.0824Z",
    stroke: "#F4F4F9",
    strokeWidth: 1.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0611 40H6.93893C5.7712 40 4.82129 39.0501 4.82129 37.8824V2.11764C4.82129 0.949911 5.7712 0 6.93893 0H33.0611C34.2288 0 35.1787 0.949911 35.1787 2.11764V37.8824C35.1787 39.0501 34.2288 40 33.0611 40ZM6.93893 0.777907C6.19991 0.777907 5.5992 1.37862 5.5992 2.11764V37.8824C5.5992 38.6214 6.19991 39.2221 6.93893 39.2221H33.0611C33.8001 39.2221 34.4008 38.6214 34.4008 37.8824V2.11764C34.4008 1.37862 33.8001 0.777907 33.0611 0.777907H6.93893Z",
    fill: "#F4F4F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckStatements);
export default __webpack_public_path__ + "static/media/Check²Statements.280052faf24c6a31d7983c6c5412b61a.svg";
export { ForwardRef as ReactComponent };